import DeleteSupplier from "@/v2/api/supplier/Delete";
import DeleteButton from "../general/Delete";

export default function SupplierDeleteButton({
    id,
    isInside = false,
}: {
    id: string;
    isInside?: boolean;
}) {
    return (
        <DeleteButton
            id={id}
            queryKey={["suppliers"]}
            deleteFn={DeleteSupplier}
            title="Delete Supplier"
            description="Are you sure you want to delete this supplier? This action cannot be undone. Click delete to confirm."
            successTitle="Supplier Deleted Successfully"
            isInside={isInside}
        />
    );
}
